import React, { Component } from "react";
import styles from "./VehicleSpecs.module.scss";
import sharedStyles from "../OrderDetailsNewVersion.module.scss";
import crStyles from "../../../customerReservation/crStyles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Grid from "@material-ui/core/Grid";
import { GetFloatToFixedValue } from "../../../../utils/GetFloatValue";
import {
  StyledBasicExpansionPanel,
  StyledBasicExpansionPanelSummary,
} from "../../../../shared/ExpansionPanels/ExpansionPanel";
import LowerCaseText from "../../../../utils/LowerCaseText";
import {
  ADDITIONAL_FEE,
  DELIVERY,
  REG_FEE,
  REG_TAX,
  SCRAP_FEE,
  GROSS_DELIVERY_FEE,
  TOTAL_ROAD_READY_PRICE,
} from "../../../../common/Constants";
import {
  IS_AUSTRIA_MARKET,
  IS_FRANCE_MARKET,
  IS_GERMAN_MARKET,
  IS_ITALY_MARKET,
  IS_NORWAY_MARKET,
  NOTNULL_OR_NOTUNDEFINED,
} from "../../../../utils/EmpUtil";
import FormatPercentage from "../../../../utils/FormatPercentage";
import { withTranslation } from "react-i18next";

class VehicleSpecs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandSpecsInfo: false,
      expandAdditionalItems: true,
    };
  }

  expandCustomerInfo() {
    this.setState({ expandSpecsInfo: !this.state.expandSpecsInfo });
  }

  expandAdditionalItems() {
    this.setState({ expandAdditionalItems: !this.state.expandAdditionalItems });
  }

  render() {
    const data = this.props.pricingStack;
    const defaultCurrency = this.props.defaultCurrency;

    function specsRow(styling, displayText, secondText, key = "") {
      return (
        displayText && (
          <Grid container key={key === "" ? displayText : key}>
            <Grid item xs={11} className={styling}>
              <div>{displayText}</div>
            </Grid>
            <Grid item xs={1} className={styling}>
              {secondText && (
                <div className={styles.priceValue}>{secondText}</div>
              )}
            </Grid>
          </Grid>
        )
      );
    }

    const TOP_LEVEL_FEES = [
      ADDITIONAL_FEE,
      GROSS_DELIVERY_FEE,
      TOTAL_ROAD_READY_PRICE,
    ];

    const MARKET_EXCLUSIONS = {
      NLD: [REG_FEE],
      NOR: [SCRAP_FEE, REG_TAX],
    };

    function getFees(data, props) {
      const isNLD =
        props.selectedMarket && props.selectedMarket.toUpperCase() === "NLD";
      const feeLabel = isNLD
        ? "VehicleSpecs.unavoidableCost"
        : "VehicleSpecs.fees";
      const feeValue = isNLD
        ? data.unavoidableCostTotalGross
        : data.totalGrossOtrCost;

      return (
        <>
          {!isNLD &&
            specsRow(
              styles.lightHeader,
              props.t(feeLabel),
              formatPriceValue(feeValue),
              "unavoidable"
            )}

          {isNLD &&
            specsRow(
              styles.lightHeader,
              props.t("VehicleSpecs.grossRetailWithOTR"),
              formatPriceValue(data.grossRetailWithOTR),
              "grossRetailWithOTR"
            )}

          {(data.totalRoadReadyPrice !== undefined ||
            data.dealerOTRCosts?.totalRoadReadyPrice !== undefined) &&
            specsRow(
              styles.lightHeader,
              props.t("VehicleSpecs.totalRoadReadyPrice"),
              formatPriceValue(
                data.totalRoadReadyPrice ??
                  data.dealerOTRCosts?.totalRoadReadyPrice
              ),
              "totalRoadReady"
            )}

          {data.dealerOTRCosts?.[ADDITIONAL_FEE] !== undefined &&
            specsRow(
              styles.lightHeader,
              props.t("VehicleSpecs.additionalFee"),
              formatPriceValue(data.dealerOTRCosts[ADDITIONAL_FEE]),
              "additionalFeeTop"
            )}

          {!isNLD &&
            data.dealerOTRCosts?.[GROSS_DELIVERY_FEE] !== undefined &&
            specsRow(
              styles.lightHeader,
              props.t("VehicleSpecs.grossDeliveryFee"),
              formatPriceValue(data.dealerOTRCosts[GROSS_DELIVERY_FEE]),
              "grossDeliveryFeeTop"
            )}

          {isNLD &&
            props.deliveryCostOnOffCost !== undefined &&
            specsRow(
              styles.lightHeader,
              props.t("VehicleSpecs.grossDeliveryFee"),
              formatPriceValue(props.deliveryCostOnOffCost),
              "deliveryCostOnOffCost"
            )}
          {data.dealerOTRCosts &&
            (() => {
              const isNor = IS_NORWAY_MARKET(props.selectedMarket);

              const excludeList = [
                ...TOP_LEVEL_FEES,
                ...(isNLD ? MARKET_EXCLUSIONS.NLD : []),
                ...(isNor ? MARKET_EXCLUSIONS.NOR : []),
              ];

              return Object.keys(data.dealerOTRCosts)
                .filter((price) => !excludeList.includes(price))
                .map((price) => {
                  return specsRow(
                    styles.darkIndentDetails,
                    props.t("VehicleSpecs." + price),
                    formatPriceValue(data.dealerOTRCosts[price]),
                    price
                  );
                });
            })()}
        </>
      );
    }

    function formatPriceValue(value) {
      if (NOTNULL_OR_NOTUNDEFINED(value)) {
        value = GetFloatToFixedValue(value, 2);
        value = value.toString();
        value =
          value.charAt(0) === "+" || value.charAt(0) === "-"
            ? value.charAt(0).concat(defaultCurrency, value.substr(1))
            : defaultCurrency.concat(value);
      } else {
        value = "--";
      }
      return value;
    }

    function getSpecs(specs, nameplate) {
      let specsDesc = nameplate ? nameplate + ": " : "";
      specsDesc = specs && specsDesc + specs.join(" / ");
      return specsDesc;
    }

    return (
      <StyledBasicExpansionPanel
        expanded={
          this.props.offlinePricingUpdate.partialOffline
            ? false
            : this.state.expandSpecsInfo
        }
        disabled={this.props.offlinePricingUpdate.partialOffline}
        onChange={() => this.expandCustomerInfo()}
      >
        <StyledBasicExpansionPanelSummary
          style={crStyles.headerBarNeutral}
          id="exp"
        >
          <div className={sharedStyles.headerBar}>
            <div className={sharedStyles.boldHeader}>
              {this.props.offlinePricingUpdate.partialOffline
                ? this.props.t(
                    "CustomerOrderDetails.vehicleSpecsHeaderPricingAgreed"
                  )
                : this.props.t("CustomerOrderDetails.vehicleSpecsHeader")}
            </div>
            {!this.props.offlinePricingUpdate.partialOffline &&
              (this.state.expandSpecsInfo ? (
                <ExpandLessIcon id="less" />
              ) : (
                <ExpandMoreIcon id="more" />
              ))}
          </div>
          <br />
        </StyledBasicExpansionPanelSummary>

        <div className={styles.vehicleInfoGrid}>
          <div className={styles.bottomBorder} />

          {data ? (
            <>
              <Grid container className={styles.specsContainer}>
                {specsRow(
                  styles.lightHeader,
                  this.props.selectedMarket &&
                    this.props.selectedMarket.toUpperCase() === "NLD"
                    ? this.props.t("VehicleSpecs.basePrice")
                    : getSpecs(data.specs, this.props.nameplate),
                  formatPriceValue(
                    this.props.selectedMarket &&
                      this.props.selectedMarket.toUpperCase() === "NLD"
                      ? data.basePriceWithVehicleRegistrationTax
                      : data.grossRetail
                  ),
                  "specs"
                )}
                {this.props.selectedMarket &&
                  this.props.selectedMarket.toUpperCase() === "NLD" &&
                  specsRow(
                    styles.lightHeader,
                    this.props.t("VehicleSpecs.registrationTaxBase"),
                    formatPriceValue(data.registrationTaxBase),
                    "registrationTaxBase"
                  )}
                {data.packPremium !== null &&
                  data.packPremium !== 0.0 &&
                  specsRow(
                    styles.darkHeader,
                    this.props.t("VehicleSpecs.packPremiumAmount"),
                    formatPriceValue(data.packPremium),
                    "options"
                  )}
                {specsRow(
                  styles.darkHeader,
                  this.props.t("VehicleSpecs.configureOptions"),
                  formatPriceValue(data.selectedFeaturePrice),
                  "options"
                )}
                {data.userSelectedFeatures &&
                  data.userSelectedFeatures.map((feature, index) =>
                    specsRow(
                      styles.darkIndentDetails,
                      feature.type,
                      formatPriceValue(feature.value),
                      index
                    )
                  )}
                {this.props.selectedMarket &&
                  this.props.selectedMarket.toUpperCase() === "NLD" &&
                  specsRow(
                    styles.lightHeader,
                    this.props.t("VehicleSpecs.registrationTaxOnOptions"),
                    formatPriceValue(data.registrationTaxOnOptions),
                    "registrationTaxOnOptions"
                  )}
                {this.props.selectedMarket &&
                  this.props.selectedMarket.toUpperCase() === "NLD" &&
                  specsRow(
                    styles.lightHeader,
                    this.props.t(
                      "VehicleSpecs.grossRetailWithVehicleRegistrationTax"
                    ),
                    formatPriceValue(
                      data.grossRetailWithVehicleRegistrationTax
                    ),
                    "grossRetailWithVehicleRegistrationTax"
                  )}
                {this.props.selectedMarket &&
                  this.props.selectedMarket.toUpperCase() === "NLD" &&
                  specsRow(
                    styles.lightHeader,
                    this.props.t("VehicleSpecs.unavoidableCost"),
                    formatPriceValue(data.unavoidableCostTotalGross),
                    "unavoidableCostTotalGross"
                  )}
                <>
                  {data.dealerOTRCosts &&
                    IS_NORWAY_MARKET(this.props.selectedMarket) &&
                    Object.keys(data.dealerOTRCosts)
                      .filter((price) => price === REG_TAX)
                      .map((price) => {
                        return specsRow(
                          styles.darkHeader,
                          this.props.t("VehicleSpecs." + price),
                          formatPriceValue(data.dealerOTRCosts[price]),
                          "otr"
                        );
                      })}
                  {IS_AUSTRIA_MARKET(this.props.selectedMarket) &&
                    specsRow(
                      styles.darkHeader,
                      this.props.t("VehicleSpecs.noVa"),
                      FormatPercentage(data.taxPercentage),
                      "nova"
                    )}
                  {!IS_FRANCE_MARKET(this.props.selectedMarket) &&
                    getFees(data, this.props)}

                  {!IS_GERMAN_MARKET(this.props.selectedMarket) &&
                    this.props.selectedMarket.toUpperCase() !== "NLD" &&
                    specsRow(
                      styles.lightHeader,
                      this.props.t("VehicleSpecs.dealerOtrTotalPrice"),
                      formatPriceValue(
                        IS_FRANCE_MARKET(this.props.selectedMarket)
                          ? data.grossRetailWithOTR
                          : data.totalDealerPrice
                      ),
                      "total"
                    )}
                  {specsRow(
                    styles.darkHeader,
                    this.props.t("VehicleSpecs.totalSavings"),
                    formatPriceValue(data.totalIncentives),
                    "savings"
                  )}
                  {this.props.selectedMarket.toUpperCase() !== "NOR" &&
                    specsRow(
                      styles.darkIndentDetails,
                      this.props.t("VehicleSpecs.governmentPlugInGrant"),
                      formatPriceValue(
                        IS_GERMAN_MARKET(this.props.selectedMarket)
                          ? data.fordOEMContribution
                          : data.governmentGrantGuaranteed
                      ),
                      "plugin"
                    )}
                  {specsRow(
                    styles.darkIndentDetails,
                    this.props.t("VehicleSpecs.oemDiscount"),
                    formatPriceValue(
                      IS_ITALY_MARKET(this.props.selectedMarket) ||
                        IS_GERMAN_MARKET(this.props.selectedMarket) ||
                        this.props.selectedMarket.toUpperCase() === "NLD"
                        ? data.grossRetailWithAccessories
                        : data.fordOEMContribution
                    ),
                    "oem"
                  )}
                  {specsRow(
                    styles.darkIndentDetails,
                    this.props.t("VehicleSpecs.dealerAdjustmentPrice"),
                    formatPriceValue(data.dealerAdjustmentPrice),
                    "adjustment"
                  )}
                  {this.props.selectedMarket &&
                    this.props.selectedMarket.toUpperCase() === "NLD" &&
                    specsRow(
                      styles.lightHeader,
                      this.props.t("VehicleSpecs.accessoriesInclFitting"),
                      formatPriceValue(data.accessoriesPriceTotal),
                      "accessoriesPriceTotal"
                    )}
                  {this.props.selectedMarket.toUpperCase() !== "NLD" &&
                    specsRow(
                      styles.lightHeader,
                      this.props.t("VehicleSpecs.dealerOtrPromotionalPrice"),
                      formatPriceValue(
                        this.props.selectedMarket.toUpperCase() === "FRA"
                          ? data.totalVehiclePriceWithSavings
                          : data.promotionalDealerPrice
                      ),
                      "promo"
                    )}
                  {this.props.selectedMarket &&
                    this.props.selectedMarket.toUpperCase() === "NLD" &&
                    specsRow(
                      styles.lightHeader,
                      this.props.t("VehicleSpecs.dealerOtrPromotionalPrice"),
                      formatPriceValue(data.totalPriceWithAddOnsNew),
                      "promoNLD"
                    )}

                  {this.props.selectedMarket &&
                    this.props.selectedMarket.toUpperCase() === "NLD" &&
                    specsRow(
                      styles.lightHeader,
                      this.props.t("VehicleSpecs.regTax"),
                      formatPriceValue(data.registrationTax),
                      "registrationTax"
                    )}

                  {this.props.selectedMarket.toUpperCase() !== "NLD" &&
                    specsRow(
                      styles.lightHeader,
                      this.props.t("VehicleSpecs.holdingDepositPaid"),
                      formatPriceValue(
                        data.orderDepositPrice
                          ? -1 * data.orderDepositPrice
                          : data.orderDepositPrice
                      ),
                      "holding"
                    )}

                  {this.props.selectedMarket &&
                    this.props.selectedMarket.toUpperCase() === "NLD" &&
                    specsRow(
                      styles.lightHeader,
                      this.props.t("VehicleSpecs.orderDeposit"),
                      formatPriceValue(data.orderDepositPrice),
                      "orderDepositPrice"
                    )}

                  {IS_FRANCE_MARKET(this.props.selectedMarket) &&
                    getFees(data, this.props)}
                </>
              </Grid>
              <StyledBasicExpansionPanel
                defaultExpanded={false}
                onChange={() => this.expandAdditionalItems()}
              >
                <StyledBasicExpansionPanelSummary
                  style={crStyles.headerBarNeutral}
                  id="exp"
                >
                  <div className={sharedStyles.nestedHeaderBar}>
                    <div>{this.props.t("VehicleSpecs.additionalItems")}</div>
                    {this.state.expandAdditionalItems ? (
                      <ExpandLessIcon id="less" />
                    ) : (
                      <ExpandMoreIcon id="more" />
                    )}
                  </div>
                  <br />
                </StyledBasicExpansionPanelSummary>
                {data.chargingAccessoriesData && (
                  <Grid container>
                    {specsRow(
                      styles.lightIndentDetails,
                      this.props.t("VehicleSpecs.charging"),
                      formatPriceValue(data.chargingPriceTotal),
                      "charging"
                    )}
                    {data.chargingAccessoriesData.chargingList.length > 0 &&
                      data.chargingAccessoriesData.chargingList.map(
                        (chargingOption) => {
                          return specsRow(
                            styles.handleLongDescText,
                            chargingOption.shortDescription,
                            formatPriceValue(chargingOption.dealerSellingPrice)
                          );
                        }
                      )}
                    {specsRow(
                      styles.darkIndentDetails,
                      this.props.t("VehicleSpecs.accessories"),
                      formatPriceValue(data.accessoriesPriceTotal),
                      "acc"
                    )}
                    {data.chargingAccessoriesData.accessoriesList.length > 0 &&
                      data.chargingAccessoriesData.accessoriesList.map(
                        (accessoriesOption) => {
                          return specsRow(
                            styles.darkDoubleIndentDetails,
                            accessoriesOption.shortDescription,
                            formatPriceValue(
                              accessoriesOption.dealerSellingPrice
                            )
                          );
                        }
                      )}
                    {this.props.appraisalAmount &&
                      specsRow(
                        styles.lightIndentDetails,
                        this.props.t("VehicleSpecs.tradeIn"),
                        this.props.appraisalAmount,
                        "tradein"
                      )}
                    {LowerCaseText(data.handOverType) === DELIVERY &&
                      data.deliveryCost !== null &&
                      specsRow(
                        styles.lightIndentDetails,
                        this.props.t("VehicleSpecs.homeDeliveryCharge"),
                        formatPriceValue(data.deliveryCost),
                        "home"
                      )}
                  </Grid>
                )}
              </StyledBasicExpansionPanel>
            </>
          ) : (
            <span className={styles.labelError}>
              {" "}
              {this.props.t("CustomerOrderDetails.errorLoadingDetails")}
            </span>
          )}
        </div>
      </StyledBasicExpansionPanel>
    );
  }
}

export default withTranslation("emp")(VehicleSpecs);
